export const removeButtonStyle = {
    position: 'absolute' as 'absolute',
    right: 10,
    top: '68%',
    transform: 'translateY(-50%)',
    padding: '5px 10px',
    fontSize: '12px',
    background: '#EA1E2B',
    minWidth: 0,
  };